// «نمایش صفحه‌ی من به پشتیبانی» (60.11.559): the bar every page of the panel shows while the customer's screen is shown -
// who is watching, for how long, back to the ticket, and «توقف». It stays while the customer moves between pages.
import {FC, useEffect, useState} from 'react'
import {Link, useLocation} from 'react-router-dom'
import {
  getScreenShare,
  ScreenShareState,
  stopScreenShare,
  subscribeScreenShare,
} from './screen-share'
import {focusCaptureWindow} from './capture-window'
import './screen-share.css'

export const clock = (ms: number) => {
  const seconds = Math.max(0, Math.floor(ms / 1000))
  const pad = (value: number) => String(value).padStart(2, '0')
  return `${Math.floor(seconds / 60)}:${pad(seconds % 60)}`.replace(/\d/g, (digit) =>
    Number(digit).toLocaleString('fa-IR')
  )
}

export const screenShareWords = (state: ScreenShareState) =>
  state.status === 'choosing'
    ? 'صفحه‌ای را که می‌خواهید نمایش دهید، در پنجره‌ی «نمایش و ضبط صفحه» انتخاب کنید'
    : state.status === 'starting'
    ? 'در حال آماده‌سازی نمایش صفحه…'
    : state.status === 'viewing'
    ? `${state.viewer || 'پشتیبانی'} صفحه‌ی شما را می‌بیند`
    : state.status === 'waiting'
    ? 'صفحه‌ی شما آماده‌ی نمایش است؛ پشتیبانی خبردار شد و به‌زودی آن را می‌بیند'
    : state.status === 'ended'
    ? 'نمایش صفحه تمام شد.'
    : ''

export const ScreenShareHost: FC = () => {
  const [state, setState] = useState<ScreenShareState>(getScreenShare)
  const [now, setNow] = useState(() => Date.now())
  const location = useLocation()

  useEffect(() => subscribeScreenShare(setState), [])

  useEffect(() => {
    if (state.status !== 'waiting' && state.status !== 'viewing') return
    const timer = window.setInterval(() => setNow(Date.now()), 1000)
    return () => window.clearInterval(timer)
  }, [state.status])

  const shown = state.status !== 'idle' && state.status !== 'starting'
  // The bar sits over the foot of the page: screen-share.css makes room below the page and lifts the ticket's reply box.
  useEffect(() => {
    document.body.classList.toggle('mp-screen-sharing', shown)
    return () => document.body.classList.remove('mp-screen-sharing')
  }, [shown])

  if (!shown) return null
  const live = state.status === 'waiting' || state.status === 'viewing'
  const ticketPath = state.ticketNumber
    ? `/apps/ticket-management/room/${encodeURIComponent(state.ticketNumber)}`
    : ''
  const onTicket = ticketPath !== '' && location.pathname === ticketPath

  return (
    <div
      className={`mp-screen-share-bar is-${state.status}`}
      role='status'
      aria-live='polite'
      dir='rtl'
    >
      <span className='mp-screen-share-bar__dot' aria-hidden='true' />
      <span className='mp-screen-share-bar__icon' aria-hidden='true'>
        <i className='bi bi-display' />
      </span>
      <span className='mp-screen-share-bar__words'>
        <strong>{screenShareWords(state)}</strong>
        {live && (
          <small>پشتیبانی فقط می‌بیند و کنترلی ندارد؛ {clock(now - (state.since || now))}</small>
        )}
      </span>
      {live && ticketPath && !onTicket && (
        <Link className='btn btn-sm btn-light mp-screen-share-bar__back' to={ticketPath}>
          بازگشت به تیکت
        </Link>
      )}
      {live && (
        <button
          type='button'
          className='btn btn-sm btn-danger mp-screen-share-bar__stop'
          onClick={stopScreenShare}
        >
          <i className='bi bi-stop-fill' aria-hidden='true' /> توقف نمایش
        </button>
      )}
      {state.status === 'choosing' && (
        <>
          <button
            type='button'
            className='btn btn-sm btn-primary'
            // The window is gone (closed by the customer): the request goes with it.
            onClick={() => focusCaptureWindow() || stopScreenShare()}
          >
            <i className='bi bi-window-stack' aria-hidden='true' /> نمایش پنجره
          </button>
          <button type='button' className='btn btn-sm btn-light' onClick={stopScreenShare}>
            انصراف
          </button>
        </>
      )}
    </div>
  )
}
